import { WHATSAPP_SUPPORT_URL } from 'constants/global';

export const openSupport = () => {
  window.openDobleAuth(WHATSAPP_SUPPORT_URL);
};
